import { Transform, Type } from 'class-transformer';
import { centTransform, dateTransform } from '../utils/helper';
import { Veicolo, veicolo } from './veicolo.model';

export class Volunteer {
    id?: number;
    pin?: string;
    badge?: string;
    volonteernumber?: number;
    type?: string;
    headquarter?: string;
    @Transform(dateTransform)
    ammissiondate?: Date; 
    reference?: string; 
    odometer?: number;
    @Transform(dateTransform)
    odolastdate?: Date;
    @Transform(dateTransform)
    applicationdate?: Date;
    @Transform(dateTransform)
    natcarddate?: Date;
    natcardnumber?: number;
    natcardyear?: number;
    companycode?: string;
    confederationcode?: string;
    @Transform(dateTransform)
    terminationdate?: Date;
    terminationreason?: string;
    vehicleid?: number;
    @Transform(centTransform)
    refundperkm?: number;
    @Type(veicolo)
    vehicle!: Veicolo;
}

export function volunteer() {
	return Volunteer;
}